import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAuthSellerBrand, IAuthSellerData, IAuthSellerRequest, IDppManagementPageData } from '../models/models'

export class GetAuthSellerBrandsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authSeller/GetAuthSellerBrands',
      requesterInfo,
    })
  }

  public async GetBrands(): Promise<IAuthSellerBrand[]> {
    return await this.getAsync<IAuthSellerBrand[]>()
  }
}
